export enum QuestionInstance {
  QUESTION_DRAG_DROP = 'QUESTION_DRAG_DROP',
  QUESTION_GAP_MATCH = 'QUESTION_GAP_MATCH',
  QUESTION_MULTIPLE_CHOICE = 'QUESTION_MULTIPLE_CHOICE',
  QUESTION_OPEN = 'QUESTION_OPEN',
  QUESTION_SELF_EXAM = 'QUESTION_SELF_EXAM',
  QUESTION_SLIDER = 'SLIDER_QUESTION',
  QUESTION_STAR = 'STAR_QUESTION',
  QUESTION_RADIO = 'RADIO_QUESTION',
  QUESTION_LIST = 'QUESTION_LIST',
  QUESTION_KEYWORD = 'QUESTION_KEYWORD',
  QUESTION_READING = 'QUESTION_READING',
}
